import React from 'react';

import { withGetFieldValuesOnFocus } from '~/hocs/withGetFieldValuesOnFocus';

import EcSelect from '../EcSelect/EcSelect';

const LazyEcSelect = withGetFieldValuesOnFocus(EcSelect);

const FieldValuesSingleSelect = (props) => {
  const { fieldId, searchSuggestions } = props;

  return (
    <LazyEcSelect
      {...props}
      fieldId={fieldId}
      searchSuggestions={searchSuggestions}
    />
  );
};

export default FieldValuesSingleSelect;
